// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"bd36365c","368":"d1014321","462":"cf9d9f89","466":"d3661871","700":"5ed600a4","715":"6c8e35b2","820":"8cecfa4c","936":"36b847d8"}[chunkId] + ".chunk.css";
};